export default __webpack_public_path__ + "static/media/Textilslöjd1.276cd68c.jpeg";